import { render } from "./LinkSupplierInvoiceToProject.vue?vue&type=template&id=4e4a7a4d"
import script from "./LinkSupplierInvoiceToProject.vue?vue&type=script&lang=js"
export * from "./LinkSupplierInvoiceToProject.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__